import { usePeriodLabel as _usePeriodLabel } from '@griply/hooks';
import { UpcomingPeriod } from '@griply/types';
import { useTranslation } from 'react-i18next';
import { useToday } from 'shared/contexts/today';

import { useData } from '../../use-data';

export type UsePeriodLabelOptions = {
  period: UpcomingPeriod;
};

export const usePeriodLabel = ({ period }: UsePeriodLabelOptions) => {
  const { t } = useTranslation();
  const today = useToday();
  const { weekStartsOn, dateFormat } = useData();

  return _usePeriodLabel({ period, today, weekStartsOn, dateFormat, t });
};
